<template>
  <input
    type="file"
    ref="input"
    @change="handleUpload"
    style="display: none"
    :accept="accept"
    :multiple="multiple"
  />
</template>

<script>
export default {
  name: "SjUpload",
  data() {
    return {
      accept: null,
      resolve: null,
      reject: null,
      multiple: null
    };
  },
  mounted() {
    this.$refs.input.click();
  },
  methods: {
    handleUpload(event) {
      if (typeof this.resolve === "function") {
        this.resolve(event.target.files);
      }
    },
    destroyElement() {
      if (typeof this.resolve === "function") {
        this.reject("canceled");
      }
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>
